const stickyElement = document.querySelector('.personal-story-section');
const initialOffset = stickyElement.offsetTop; // Relative to the document
const stickPosition = document.querySelector('#testimonials-trigger').offsetTop;
window.addEventListener('scroll', () => {
    if (window.scrollY >= stickPosition) {
        stickyElement.classList.remove('hold-sticky'); // Remove the class when not sticky
        stickyElement.classList.add('sticky-active'); // Add a class to apply sticky styles
    } else {
        stickyElement.classList.remove('sticky-active'); // Remove the class when not sticky
        stickyElement.classList.add('hold-sticky'); // Remove the class when not sticky
    }
});